import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal, Select } from "antd";
import NotificationWithIcon from "../../../components/NotificationWithIcon";
import { useTranslation } from "react-i18next";
import {
  ChangeTransactionTable,
  getDiningTables,
} from "../../../network/network";
import { AppContext } from "../../../context/AppContextProvider";
import { handleApiError } from "../../../utils/errorHandler";

const UpdateTable = ({ order, reloadCallback }) => {
  const { authUser } = useContext(AppContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [loadingBTN, setLoadingBTN] = useState(false);
  const [diningTables, setDiningTables] = useState([]);
  const { t } = useTranslation();
  const [UpdateDiningTableForm] = Form.useForm();

  useEffect(() => {
    setLoadingBTN(true);
    getDiningTables()
      .then((response) => {
        let data = response.data || response.response.data;
        if (data.success === true) {
          setDiningTables(response.data.data.dining_tables);
        } else if (data?.success === false) {
          handleApiError(response, t);
        }
      })
      .catch((error) => handleApiError(error, t))
      .finally(() => {
        setLoadingBTN(false);
      });
  }, [t]);

  const showEditModel = () => {
    // Set Form Fields
    UpdateDiningTableForm.setFieldsValue({
      id: order.id,
      dining_table_id: order.dining_table_id,
    });
    setModalVisible(true);
  };

  const handleUpdateTable = () => {
    UpdateDiningTableForm.validateFields()
      .then((values) => {
        // Set Loading True
        setLoadingBTN(true);
        // Sending Request to API
        ChangeTransactionTable(values)
          .then((response) => {
            let data = response.data || response.response.data;
            if (data.success === true) {
              // Success
              NotificationWithIcon(
                "success",
                t("entity_updated"),
                response.data.message,
              );
              reloadCallback();
            } else if (data?.success === false) {
              handleApiError(response, t);
            }
            // Hide Modal
            setModalVisible(false);
          })
          .catch((error) => handleApiError(error, t))
          .finally(() => {
            // Set Loading False
            setLoadingBTN(false);
          });
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <>
      <Button type="default" onClick={showEditModel}>
        {order.dining_table_name
          ? t("update_table")
          : t("assign_table_to_order")}
      </Button>

      <Modal
        title={order.dining_table_name ? t("update_table") : t("add_table")}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
        onOk={handleUpdateTable}
        footer={[
          <Button
            type="default"
            key="back"
            loading={loadingBTN}
            onClick={() => setModalVisible(false)}
          >
            {t("cancel")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loadingBTN}
            onClick={handleUpdateTable}
          >
            {order.dining_table_name ? t("update") : t("add")}
          </Button>,
        ]}
      >
        <Form
          name="assign-table-form"
          layout="vertical"
          onFinish={handleUpdateTable}
          className="app-w-full"
          form={UpdateDiningTableForm}
        >
          <Form.Item
            name="dining_table_id"
            label={t("select_table")}
            rules={[
              {
                required: true,
                message: t("validate_table_required"),
              },
            ]}
            hasFeedback
          >
            <Select
              showSearch
              allowClear
              options={diningTables
                .filter((table) => {
                  if (table.branch.id === authUser.branch_id) {
                    return table;
                  } else return null;
                })
                .map((table) => {
                  return {
                    label: table.name,
                    value: table.id,
                  };
                })}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
          <Form.Item name="id" className="app-hidden">
            <input type="hidden" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default UpdateTable;
